import styled from '@emotion/styled';

import { COLOR_TEXT_MUTED } from './utils/variables';

export const SectionMeta = styled.span`
  font-size: 13px;
  color: ${COLOR_TEXT_MUTED};
`;
